import { LNF_MAX_GRADE } from "../../contracts/study";
import { PREDICTED_KNOWN_MIN_P } from "../../corpus/passages";

export const AWRF_CONFIG = {
  // Sourced from contracts/study.ts, whose copy value-fidelity.test.ts pins;
  // a second literal here would be a copy the fidelity test does not guard.
  LNF_MAX_GRADE,
  AWRF_MAX_GRADE: 3,
} as const;

/**
 * How long, after the final 60 s, the end of the runway waits for a
 * still-loading prediction model before aWRF may end with no adaptive words.
 * The runway is only 6–12 words, so a slow download would otherwise leave it
 * empty.
 */
export const ADAPTIVE_WORDS_WAIT_MS = 20_000;

/** Bump on any change to the selection algorithm, its RNG or a policy field. */
export const AWRF_POLICY_VERSION = 1;

/** Share of adaptive words drawn from predicted-known candidates; the rest are predicted-unknown. */
export const AWRF_TARGET_KNOWN_RATIO = 0.8;
/** Texts `selectReadings` returns for the candidate vocabulary. */
export const AWRF_CANDIDATE_TEXTS = 10;
/** The most texts a widened candidate request may ask for. */
export const AWRF_CANDIDATE_TEXTS_MAX = 40;
export const AWRF_INITIAL_QUEUE = 24;
export const AWRF_REFILL_AFTER = 12;
export const AWRF_REFILL_SIZE = 12;
/** 16 rows of 6. */
export const AWRF_ADAPTIVE_MAX_WORDS = 96;

export interface AwrfAdaptivePolicy {
  readonly version: number;
  readonly targetKnownRatio: number;
  /** Calibrated P(known) at or above which a candidate is predicted known. */
  readonly predictedKnownMinP: number;
  readonly candidateTexts: number;
  readonly candidateTextsMax: number;
  readonly initialQueue: number;
  readonly refillAfter: number;
  readonly refillSize: number;
  readonly maxWords: number;
}

export const DEFAULT_AWRF_ADAPTIVE_POLICY: AwrfAdaptivePolicy = {
  version: AWRF_POLICY_VERSION,
  targetKnownRatio: AWRF_TARGET_KNOWN_RATIO,
  // The selector's own boundary, so a word aWRF calls predicted-known is one
  // the reading selector counts as known.
  predictedKnownMinP: PREDICTED_KNOWN_MIN_P,
  candidateTexts: AWRF_CANDIDATE_TEXTS,
  candidateTextsMax: AWRF_CANDIDATE_TEXTS_MAX,
  initialQueue: AWRF_INITIAL_QUEUE,
  refillAfter: AWRF_REFILL_AFTER,
  refillSize: AWRF_REFILL_SIZE,
  maxWords: AWRF_ADAPTIVE_MAX_WORDS,
};
